import {
  SPAIN_COUNTRY_CODE,
  SPAIN_WARRANTY_ASSET,
} from '../../../utils/constant';
import EquipmentViewPopup from '../EquipmentViewPopup';

import {Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './EquipmentModelsView.css';

const EquipmentModelsView = (props) => {
  const {t} = useTranslation();
  const [visible, setVisible] = React.useState(false);
  const [modelsList, setModelsList] = React.useState([]);

  React.useEffect(() => {
    if (props.selectedContract && props.contractDetails) {
      let assetsDetails = props.contractDetails[props.selectedContract]?.assets;

      let modelList = [];
      if (props.countryCode === SPAIN_COUNTRY_CODE) {
        assetsDetails?.map((asset) => {
          if (asset?.model?.modelName.toLowerCase() !== SPAIN_WARRANTY_ASSET) {
            modelList.push(asset.serialNumber);
          }
        });
      } else {
        modelList = assetsDetails?.map((asset) => asset.description);
      }
      setModelsList(modelList);
    }
  }, [props.contractDetails, props.selectedContract]);

  return (
    <>
      {modelsList && modelsList.length > 0 && (
        <div className="assetsModelView" data-testid="assetsModelView">
          {props.hideTitle ? null : t('MODELS')}
          <span className="assetsModelNamesView">
            {modelsList?.slice(0, 1).join(', ')}
            {` `}
          </span>
          {modelsList?.length - 1 > 0 && (
            <Button
              id="equipmentViewMore"
              variant="text-inline"
              onClick={() => setVisible(true)}
            >
              {`+`}
              {modelsList?.length - 1}
            </Button>
          )}
        </div>
      )}
      <EquipmentViewPopup
        id="EquipmentPopupModal"
        title={t('ASSET_DETAILS')}
        visible={visible}
        setVisible={setVisible}
        selectedContractNumber={props.selectedContract}
      />
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    contractDetails: state.appStates.contractDetails?.accountDetails,
    countryCode: state.appStates.allContracts?.countryCode,
  };
};

export default connect(mapStateToProps)(EquipmentModelsView);
